module.exports = __webpack_public_path__ + "static/media/canReverseQuestion.b8b43f1a.mp3";